import React, { Component } from 'react';
import logo from "../../images/GM-Cabs-card-logo.jpg";
import {
    Link, withRouter, NavLink
} from 'react-router-dom';

import '../../stylesheet/hoverdropdown.css'
import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const styles = {
    activeStyle: {
        backgroundColor: "#fff",
        boxShadow: "0 0px 0px 0px rgba(42, 81, 148, 0.2), 0 16px 16px -11px rgba(42, 81, 148, 0.6)",
        border: "1px solid #f5f5f5",
        borderBottom: "2px solid #333",
    }
}
const mapStateToProps = state =>
    ({
        profileState: state.getProfileReducer.profileState,
        display: state.getProfileReducer.display,
        optionState: state.selectedTabReducer.selectedTabReducer,
    })

const mapDispatchToProps = dispatch =>
    ({
        fetchProfileState() {
            dispatch(
                actions.getProfileAction()
            )
        },
        fetchSelectedTab(selectedOption) {
            dispatch(
                actions.selectedtabAction(selectedOption)
            )
        },
    })

class AuthNavbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "home",
            pageExpiresIn: "",
            selectedOption: localStorage.getItem("taboption"),
            expiryvalue: "first"

        }
        this.handleActive = this.handleActive.bind(this)
    }
    handleActive(e) {
        let _this = this
        const { profileState } = this.props
        this.setState({
            selectedOption: "tab1"
        }, () => {
            localStorage.setItem("taboption", "tab1")
            _this.props.fetchSelectedTab(this.state.selectedOption)
            _this.props.history.push("/my-profile/" + profileState.body.firstName + "." + profileState.body.lastName)

        })
    }
    handleProfile(e) {
        let _this = this
        const { profileState } = this.props
        this.setState({
            selectedOption: "tab1"
        }, () => {
            localStorage.setItem("taboption", "tab1")
            _this.props.fetchSelectedTab(this.state.selectedOption)
            _this.props.history.push("/my-profile/" + profileState.body.firstName + "." + profileState.body.lastName)

        })

    }

    componentDidMount() {
        let expiry = JSON.parse(localStorage.getItem("expiryTime"))
        let expiryTime = new Date(expiry)
        let time = expiryTime.getTime()
        let _this = this

        if (this.state.expiryvalue = "first") {
            this.Interval = setTimeout(function () {
                // let currentDate = new Date();
                // var current = currentDate.getTime();
                // if (time <= current) {
                clearInterval(this.Interval)

                localStorage.clear();
                _this.props.history.push("/sessionout")

            }, 1800000)
            this.setState({
                Interval: this.Interval,
                expiryvalue: "second"
            })
        }



    }
    componentWillUnmount() {
        const notProfile = localStorage.setItem("comp", "othercomp")
        let expiry = JSON.parse(localStorage.getItem("expiryTime"))
        let expiryTime = new Date(expiry)
        let time = expiryTime.getTime()
        let currentDate = new Date();
        var current1 = currentDate.getTime();

        if (time <= current1) {

            clearInterval(this.Interval)
        }
    }

    // incrementTime(){
    //    let incTime= JSON.parse(this.state.pageExpiresIn)  + 60000
    //    let _this=this
    //    this.setState({
    //     pageExpiresIn: incTime
    //    },()=>{

    //    })
    // }
    render() {
        // const { profileState } = this.props
        return (
            <div className="col-sm-12">
                <nav className="navbar navbar-expand-sm bg-trans navbar-dark fixed-top" >
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable
                        pauseOnHover
                    />
                    <a className="navbar-brand" ><img src={logo} alt='' style={{ height: 70, width: 170 }} /></a>
                    <ul className="navbar-nav" style={{ width: "100%" }}>
                        <li className="nav-item nav-tab-padding ">
                            <NavLink exact activeStyle={styles.activeStyle} to="/home" className="nav-link text-dark">
                                Home
                        </NavLink>
                        </li>
                        <li className="nav-item nav-tab-padding dropdown">
                            <NavLink to="/card-summary" activeStyle={styles.activeStyle} className="nav-link text-dark dropbtn" >My Cards</NavLink>
                            <div className="dropdown-content">
                                <Link to="/card-summary">Card Summary</Link>
                                <Link to="/card-activity">Card Activity</Link>
                            </div>
                        </li>
                        <li className="nav-item nav-tab-padding dropdown">
                            <NavLink to="/share-funds" activeStyle={styles.activeStyle} className="nav-link text-dark dropbtn">Transfer Funds</NavLink>
                            <div className="dropdown-content">
                                <Link to="/friends&family">Card Accounts</Link>
                                <Link to="/transfer-history">Transfer History</Link>
                                <Link to="/share-funds">Share Funds</Link>
                            </div>
                        </li>
                        <li className="nav-item nav-tab-padding dropdown">
                            <NavLink to="/manage-my-profile" onClick={this.handleProfile.bind(this)} activeStyle={styles.activeStyle} className="nav-link text-dark dropbtn">Additional Services</NavLink>
                            <div className="dropdown-content">

                                <Link to="/manage-my-profile" onClick={this.handleActive.bind(this)}>Manage My Profile</Link>
                                <Link to="/change-password">Change Password</Link>
                                <Link to="/change-pin">Change PIN</Link>
                                <Link to="/block-card">Block/Unblock Card</Link>
                            </div>
                        </li>
                        <li className="nav-item nav-tab-padding">
                            <NavLink to="/authcontact-us" activeStyle={styles.activeStyle} className="nav-link text-dark">Contact Us</NavLink>
                        </li>
                        <li className="nav-item nav-tab-padding">
                            <NavLink to="/faqs" activeStyle={styles.activeStyle} className="nav-link text-dark">FAQs</NavLink>
                        </li>
                        <li className="nav-item nav-tab-padding">
                            <NavLink to="/loadcard" activeStyle={styles.activeStyle} className="nav-link text-dark">Load Card</NavLink>
                        </li>
                    </ul>
                </nav >
            </div>
        )
    }
}

// AuthNavbar.defaultProps = {
//     profileState: {
//         status: 400
//     }
// }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthNavbar));


// WEBPACK FOOTER //
// ./src/components/navigation/authnavigation.jsx